export default "<router-outlet></router-outlet>\n<app-sidebar></app-sidebar>\n"